/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_Ingest_ErrorInputs */

const es_tools_legajox_ingest_error = /** @type {(inputs: Tools_Legajox_Ingest_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al ingestar archivos de Legajox`)
};

const en_tools_legajox_ingest_error = /** @type {(inputs: Tools_Legajox_Ingest_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error ingesting Legajox files`)
};

/**
* | output |
* | --- |
* | "Error ingesting Legajox files" |
*
* @param {Tools_Legajox_Ingest_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_ingest_error = /** @type {((inputs?: Tools_Legajox_Ingest_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_Ingest_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_ingest_error(inputs)
	return en_tools_legajox_ingest_error(inputs)
});
export { tools_legajox_ingest_error as "tools.legajox.ingest_error" }